import { render, staticRenderFns } from "./SubscriptionShow.vue?vue&type=template&id=60d52aba&"
import script from "./SubscriptionShow.vue?vue&type=script&lang=js&"
export * from "./SubscriptionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports